import React, { useContext } from "react";

import { Card, Col, Row } from "react-bootstrap";
import PsContext from "../../../context";
import LoginForm from "../../login/loginForm";
import Announcement from "./announcement";
import HelpLineInfo from "./helpLineInfo";
import { webBannerImage, COLLEGE } from "../../../utils";
import ProgrammesOfferedPage from "./programmesOfferedPage";
import TopScrollAnnouncement from "./topScrollAnnouncement";
import StepsToFollow from "./stepsToFollow";
import AdmissionHeroLeft from "./admissionHeroLeft";

const HomePage = (props) => {
  const context = useContext(PsContext);

  return (
    <>
      {Number(context.settingValue("show_admission_model")) === 1 && (
        <TopScrollAnnouncement />
      )}
      <section
        className="bg-section position-relative d-flex align-items-center"
        style={{
          minHeight: "650px",
          backgroundImage: `url(${webBannerImage()})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div
          className="position-absolute w-100 h-100 top-0 start-0"
          style={{ backgroundColor: "#0c234063" }}
        ></div>

        <div className="container-fluid px-4 position-relative z-1 py-2">
          <Row className="justify-content-between align-items-center">
            <Col
              md={8}
              className="mb-4 mb-md-0 d-flex flex-column justify-content-center"
            >
              <AdmissionHeroLeft />
            </Col>

            <Col
              md={4}
              className="slide-up-animation-delay-2 h-100 d-flex align-items-center justify-content-end"
            >
              <LoginForm />
            </Col>
          </Row>
        </div>
      </section>

      <StepsToFollow />

      <HelpLineInfo />

      <section className="bg-white">
        <div className="container py-5">
          <Row className="g-4">
            <Col md={7}>
              <div className="pe-md-4">
                <Announcement />
              </div>
            </Col>

            <Col md={5}>
              <div className="bg-light p-4 rounded-4 border border-opacity-10 h-100">
                <h4
                  className="fw-800 text-dark mb-4 fs-18 position-relative pb-2"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  Why Apply Online?
                  <span
                    className="position-absolute bottom-0 start-0 bg-primary"
                    style={{
                      width: "40px",
                      height: "3px",
                      borderRadius: "2px",
                    }}
                  ></span>
                </h4>

                <div className="d-flex flex-column gap-3">
                  {[
                    {
                      title: "Seamless Registration",
                      subtitle: "Quick and easy profile creation",
                      icon: "fa-user-check",
                      variant: 1,
                    },
                    {
                      title: "Real-time Tracking",
                      subtitle: "Monitor application status",
                      icon: "fa-magnifying-glass-chart",
                      variant: 2,
                    },
                    {
                      title: "Secure Documents",
                      subtitle: "Safe digital storage",
                      icon: "fa-shield-halved",
                      variant: 3,
                    },
                    {
                      title: "Digital Payments",
                      subtitle: "Safe & Reliable fee collection",
                      icon: "fa-credit-card",
                      variant: 4,
                    },
                    {
                      title: "24/7 Accessibility",
                      subtitle: "Apply anytime, anywhere easily",
                      icon: "fa-earth-americas",
                      variant: 6,
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className={`d-flex align-items-center bg-white p-3 rounded-3 shadow-sm border-0 transition-all hvr-translate-y step-variant-${item.variant}`}
                    >
                      <div
                        className="program-icon-box p-2 rounded-2 me-3 fs-16"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <i className={`fa-solid ${item.icon}`}></i>
                      </div>
                      <div>
                        <h6 className="fw-700 m-0 fs-14 text-dark">{item.title}</h6>
                        <small className="text-muted fs-11">{item.subtitle}</small>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <ProgrammesOfferedPage />
    </>
  );
};

export default HomePage;
